import * as actionTypes from './actionTypes'
import { LOGOUT_USER } from '../user/actionTypes'

const initialState = {
    notificationList: { notifications: [], total: 0, error: null, loading: false }
}

export default (state = initialState, action) => {
    switch (action.type) {

        case actionTypes.FETCH_NOTIFICATIONS:
            return {
                ...state,
                notificationList: { ...state.notificationList, error: null, loading: true }
            }

        case actionTypes.FETCH_NOTIFICATIONS_SUCCESS:
            return {
                ...state,
                notificationList: { notifications: action.payload.notifications, total: action.payload.total, error: null, loading: false }
            }

        case actionTypes.FETCH_NOTIFICATIONS_FAILURE:
            return {
                ...state,
                notificationList: { notifications: [], total: 0, error: action.payload.error, loading: false }
            }

        case actionTypes.RESET_NOTIFICATIONS:
            return { ...state, notificationList: initialState.notificationList }



        case LOGOUT_USER:
            return initialState;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/notification/reducer.js